<h1 mat-dialog-title>{{ titles[state] }}</h1>

<mat-dialog-content>
  <div>
    <div class="txt" [innerHtml]="text[state]">
    </div>

    @if (state=='PROCESSING') {
      <mat-icon class="rotating" svgIcon="spin"></mat-icon>
    }
    @if (percentComplete && percentComplete < 100) {
      <div class="show-progress">
        {{ percentComplete }}%
      </div>
    }

    @if (state=='ERROR') {
      <div class="fade-in">
        <mat-icon svgIcon="error" color="warning"></mat-icon>
      </div>
    }
    @if (state=='DONE') {
      <div class="wipe-right">
        <mat-icon svgIcon="check"></mat-icon>
      </div>
    }
  </div>
</mat-dialog-content>

@if (state=='DONE' && (yesButton || noButton)) {
  <mat-dialog-actions class="fx-layout-row"
                    [class]="{
                      'fx-align--space-between-x': noButton && yesButton,
                      'fx-align--center-x': !noButton || !yesButton
                    }"
    >
    @if (yesButton) {
      <button mat-flat-button color="primary" [ngClass]="{'full-width':!noButton}" [mat-dialog-close]="true">
        @if (yesButton.icon) {
          <mat-icon [svgIcon]="yesButton.icon"></mat-icon>
        }
        {{ yesButton.text }}
      </button>
    }
    @if (noButton) {
      <button mat-flat-button color="secondary" [mat-dialog-close]="false" [ngClass]="{'full-width':!yesButton}">
        {{ noButton.text }}
        @if (noButton.icon) {
          <mat-icon [svgIcon]="noButton.icon"></mat-icon>
        }
      </button>
    }
  </mat-dialog-actions>
}

@if (state=='ERROR') {
  <mat-dialog-actions class="fx-layout-row">
    <button mat-flat-button class="full-width" color="primary" [mat-dialog-close]="false">
      Close Window
    </button>
  </mat-dialog-actions>
}
